import React from 'react';
import './OffshoreServices.css';

const OffshoreServices = () => {
  const services = [
    {
      id: 1,
      title: "Offshore Engineering & Design",
      items: [
        { title: "Platform Design", description: "Complete engineering for offshore platforms and structures." },
        { title: "Subsea Systems", description: "Design of underwater equipment and pipeline systems." },
        { title: "Marine Engineering", description: "Naval architecture and marine system design." }
      ]
    },
    {
      id: 2,
      title: "Project Management Services",
      items: [
        { title: "Planning & Scheduling", description: "Comprehensive project planning and timeline management." },
        { title: "Cost Control", description: "Budget management and cost optimization strategies." },
        { title: "Risk Management", description: "Identification and mitigation of project risks." }
      ]
    },
    {
      id: 3,
      title: "Technical Support Services",
      items: [
        { title: "Installation Support", description: "Technical assistance during offshore installation." },
        { title: "Commissioning", description: "System testing and commissioning services." },
        { title: "Maintenance Planning", description: "Preventive and corrective maintenance strategies." }
      ]
    },
    {
      id: 4,
      title: "Environmental Services",
      items: [
        { title: "Environmental Impact", description: "Assessment and management of environmental impacts." },
        { title: "Compliance", description: "Ensuring adherence to environmental regulations." },
        { title: "Sustainability", description: "Implementation of sustainable practices." }
      ]
    },
    {
      id: 5,
      title: "Safety Management",
      items: [
        { title: "Safety Analysis", description: "Comprehensive safety assessments and audits." },
        { title: "Emergency Response", description: "Planning and preparation for emergency situations." },
        { title: "Training Programs", description: "Safety training and certification services." }
      ]
    },
    {
      id: 6,
      title: "Quality Assurance",
      items: [
        { title: "Quality Control", description: "Inspection and testing of materials and equipment." },
        { title: "Documentation", description: "Maintenance of quality records and certificates." },
        { title: "Standards Compliance", description: "Adherence to international quality standards." }
      ]
    }
  ];

  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>Offshore Services</h2>
            </div>
          </div>
        </div>
      </div>

      {/* Offshore Services Section */}
      <div className="offshore-services">
        <div className="container">
          <div className="section-header text-center">
            <p>Our Professional Services</p>
            <h2>Offshore Excellence</h2>
          </div>
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-6 col-md-12">
                <div className="service-item">
                  <div className="service-header">
                    <div className="service-number">{String(service.id).padStart(2, '0')}</div>
                    <h3>{service.title}</h3>
                  </div>
                  <div className="service-content">
                    <ul>
                      {service.items.map((item, index) => (
                        <li key={index}>
                          <strong>{item.title}:</strong> {item.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default OffshoreServices;